import { useEffect, useRef } from 'react';

export function useOnTransition<T>(value: T, onTransition: (previous: T, next: T) => void): void {
  const previous = useRef(value);
  useEffect(() => {
    if (Object.is(previous.current, value)) return;
    onTransition(previous.current, value);
    previous.current = value;
  }, [value, onTransition]);
}
